module.exports = __webpack_public_path__ + "static/media/Account.7efcfc5f.svg";